import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Typography, Divider } from "@mui/material";
import TertiaryButton from "../../Buttons/TertiaryButton/TertiaryButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { parseAndFormatDate } from "../../../utils/dateHelpers";

export default function TextStepper({ callInByOrder, currentStatus }) {
  
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = callInByOrder.length;
  const brokerageStatus = currentStatus || "";

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <>
      <Box sx={{ display: "flex", width:"100%" }}>
        <TertiaryButton 
          onClick={handleBack} 
          disabled={activeStep === 0}
          startIcon={ArrowBackIosIcon}
          width="60px"
        />    
        <Box sx={{ width:"100%", height:"78px", overflowY: "auto" }} >
          <Box sx={{ display: "flex",margin:"6px 0" }}>
            <Typography variant="subhead1" color="black_solid.60"><strong>{parseAndFormatDate(callInByOrder[activeStep]?.callDateTime, "MM/dd/yy HH:mm")}</strong></Typography>
            <Typography variant="subhead1" color="black_solid.60" sx={{ margin:"0 12px" }}><><strong>{callInByOrder[activeStep]?.city}</strong>, <strong>{callInByOrder[activeStep]?.state}</strong></></Typography>
            <Typography variant="subhead1" color="black_solid.60" sx={{ margin:"0 12px" }}><>Type <strong>{callInByOrder[activeStep]?.initiatedType}</strong></></Typography>
            <Typography variant="subhead1" color="black_solid.60" sx={{ margin:"0 12px" }}><>Status <strong>{brokerageStatus}</strong></></Typography>
            <Typography variant="subhead1" color="black_solid.60" sx={{ margin:"0 12px" }}><>Entered by <strong>{callInByOrder[activeStep]?.enteredBy}</strong></></Typography>
          </Box>
          <Box>
            <Typography variant="subhead1" color="primary.60">{callInByOrder[activeStep]?.comments}</Typography>
          </Box>
        </Box>
        <TertiaryButton 
          onClick={handleNext} 
          disabled={activeStep === maxSteps - 1}
          startIcon={ArrowForwardIosIcon}
          width="60px"
        />   
      </Box>
      <Divider sx={{ backgroundColor: "black_solid.50", height: "1px", borderRadius: "5px", margin:"3px 0" }} />
    </>
  );
}

TextStepper.propTypes = {
  callInByOrder: PropTypes.array.isRequired,
  currentStatus: PropTypes.string.isRequired,
};
